/**
 * BBQ Rescher storefront interactions.
 *
 * This implementation intentionally uses browser-native APIs so it does not
 * depend on jQuery being loaded before this file.
 */
(function () {
  'use strict';

  function closestElement(event, selector) {
    return event.target instanceof Element ? event.target.closest(selector) : null;
  }

  function checkboxIsChecked(id) {
    var checkbox = document.getElementById(id);
    return checkbox instanceof HTMLInputElement && checkbox.checked;
  }

  function blockAction(event, message) {
    event.preventDefault();
    event.stopPropagation();
    window.alert(message);
  }

  function initializeStorefrontInteractions() {
    document.body.addEventListener('click', function (event) {
      var checkoutTrigger = closestElement(
        event,
        '[name="checkout"], [name="goto_pp"], [name="goto_gc"]'
      );

      if (
        checkoutTrigger &&
        (!checkboxIsChecked('agree_agb') || !checkboxIsChecked('agree_widerruf'))
      ) {
        blockAction(
          event,
          'Bitte akzeptieren Sie unsere Bedingungen, bevor Sie Ihren Kauf fortsetzen.'
        );
        return;
      }

      var contactTrigger = closestElement(event, '[name="contact-submit"]');

      if (contactTrigger && !checkboxIsChecked('agree_contact')) {
        blockAction(
          event,
          'Bitte akzeptieren Sie unsere Datenschutzhinweise, bevor Sie Ihre Nachricht absenden.'
        );
      }
    });

    if (window.location.pathname !== '/') {
      return;
    }

    var section = document.querySelector('section[data-custom-class="home-video"]');
    if (!section) {
      return;
    }

    var videos = section.querySelectorAll('.home-video');
    var youtubeVideo = section.querySelector('.home-video.youtube');
    var iframe = section.querySelector('.responsive-video iframe');

    videos.forEach(function (video) {
      video.addEventListener('click', function () {
        videos.forEach(function (item) {
          item.style.display = 'none';
        });

        if (youtubeVideo) {
          youtubeVideo.style.display = 'block';
        }

        if (iframe) {
          var videoUrl = new URL(iframe.src, window.location.href);
          videoUrl.searchParams.set('autoplay', '1');
          iframe.src = videoUrl.toString();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStorefrontInteractions);
  } else {
    initializeStorefrontInteractions();
  }
})();

(function () {
  'use strict';
  if (window.BBQRLeadAttributionV1) return;

  var storageKey = 'bbqr_attribution_v1';
  var pendingKey = 'bbqr_catering_pending_v1';
  var referencePrefix = 'bbqr_catering_reference_v1:';
  var maxAge = 30 * 60 * 1000;
  var campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var clickKeys = ['gclid', 'gbraid', 'wbraid', 'fbclid'];
  var record = null;

  function consent() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return {
        analytics: !!(privacy && privacy.analyticsProcessingAllowed()),
        marketing: !!(privacy && privacy.marketingAllowed())
      };
    } catch (error) {
      return { analytics: false, marketing: false };
    }
  }

  function read(key) {
    try { return JSON.parse(window.sessionStorage.getItem(key) || 'null'); }
    catch (error) { return null; }
  }

  function write(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); }
    catch (error) {}
  }

  function remove(key) {
    try { window.sessionStorage.removeItem(key); }
    catch (error) {}
  }

  function clean(value, isClick) {
    if (typeof value !== 'string' || value.length > (isClick ? 256 : 160)) return '';
    if (/@|%40|[<>\r\n]|:\/\//i.test(value)) return '';
    if (isClick) return /^[a-z0-9._~-]+$/i.test(value) ? value : '';
    return /^[a-z0-9\u00c0-\u024f _./:()\-]+$/i.test(value) ? value.trim().toLowerCase().replace(/\s+/g, '_') : '';
  }

  function pathOnly(url) {
    var path = url.pathname || '/';
    if (path.length > 240 || /@|%40/i.test(path)) return '/';
    return /^\/(?:$|pages\/|products\/|collections\/|blogs\/|cart(?:\/|$)|search(?:\/|$))/.test(path) ? path : '/';
  }

  function currentTouch(allowed) {
    var url = new URL(window.location.href);
    var touch = { campaign: {}, clicks: {}, landing_path: pathOnly(url), referrer_host: '', recorded_at: Date.now() };
    campaignKeys.forEach(function (key) {
      var value = clean(url.searchParams.get(key), false);
      if (value) touch.campaign[key] = value;
    });
    if (allowed.marketing) {
      clickKeys.forEach(function (key) {
        var value = clean(url.searchParams.get(key), true);
        if (value) touch.clicks[key] = value;
      });
    }
    try {
      var host = new URL(document.referrer).hostname.toLowerCase();
      if (host !== window.location.hostname && !/(^|\.)bbq-rescher\.de$/.test(host) && host !== 'bbq-rescher-gmbh.myshopify.com' && host !== 'shopify.com') {
        touch.referrer_host = host.slice(0, 120);
      }
    } catch (error) {}
    return touch;
  }

  function validRecord(value) {
    function touchValid(touch) {
      return touch && typeof touch === 'object' && typeof touch.landing_path === 'string' && Object.prototype.toString.call(touch.campaign) === '[object Object]' && Object.prototype.toString.call(touch.clicks) === '[object Object]';
    }
    return value && value.version === 1 && typeof value.updated_at === 'number' && Date.now() - value.updated_at >= 0 && Date.now() - value.updated_at < maxAge && touchValid(value.first) && touchValid(value.last);
  }

  function refresh() {
    var allowed = consent();
    if (!allowed.analytics && !allowed.marketing) {
      record = null;
      remove(storageKey);
      remove(pendingKey);
      clearFormFields();
      return;
    }
    var previous = record || read(storageKey);
    record = validRecord(previous) ? previous : null;
    var touch = currentTouch(allowed);
    if (!record) record = { version: 1, first: touch, last: touch, updated_at: Date.now() };
    else if (Object.keys(touch.campaign).length || Object.keys(touch.clicks).length) record.last = touch;
    if (!allowed.marketing) {
      record.first.clicks = {};
      record.last.clicks = {};
    }
    record.updated_at = Date.now();
    write(storageKey, record);
    clearFormFields();
  }

  function clearFormFields() {
    var fields = document.querySelectorAll('[data-bbqr-attribution-field="true"]');
    for (var i = 0; i < fields.length; i++) fields[i].remove();
  }

  function addField(form, label, value) {
    if (!value) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'contact[' + label + ']';
    input.value = String(value);
    input.setAttribute('data-bbqr-attribution-field', 'true');
    form.appendChild(input);
  }

  function newReference() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return 'bbqr-lead-' + window.crypto.randomUUID();
    return 'bbqr-lead-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function referenceValid(value) {
    return typeof value === 'string' && /^bbqr-lead-[a-z0-9-]{8,54}$/.test(value) && value.length <= 64;
  }

  function prepareForm(event) {
    try {
      var form = event.target;
      if (!form || form.tagName !== 'FORM' || form.method.toLowerCase() !== 'post') return;
      var action = new URL(form.action, window.location.href);
      if (action.origin !== window.location.origin || action.pathname !== '/contact') return;
      if (!form.querySelector('input[name="form_type"][value="contact"]')) return;
      var allowed = consent();
      if ((allowed.analytics || allowed.marketing) && !validRecord(record)) refresh();
      var owned = form.querySelectorAll('[data-bbqr-attribution-field="true"]');
      for (var i = 0; i < owned.length; i++) owned[i].remove();
      var reference = form.getAttribute('data-bbqr-request-reference');
      if (!referenceValid(reference)) {
        reference = newReference();
        form.setAttribute('data-bbqr-request-reference', reference);
      }
      addField(form, 'BBQR Anfrage-ID', reference);
      addField(form, 'BBQR Einwilligung', 'Analysen: ' + (allowed.analytics ? 'ja' : 'nein') + '; Marketing: ' + (allowed.marketing ? 'ja' : 'nein'));
      if (!allowed.analytics && !allowed.marketing) {
        addField(form, 'BBQR Quellenstatus', 'Nicht zugeordnet: keine Mess-Einwilligung');
        return;
      }
      if (record && record.last) {
        var touch = record.last;
        addField(form, 'BBQR Quellenmodell', 'Letzte markierte Kampagne dieser Sitzung; 30 Minuten Inaktivitaet');
        addField(form, 'BBQR Quelle', clean(touch.campaign.utm_source, false));
        addField(form, 'BBQR Medium', clean(touch.campaign.utm_medium, false));
        addField(form, 'BBQR Kampagne', clean(touch.campaign.utm_campaign, false));
        addField(form, 'BBQR Anzeige', clean(touch.campaign.utm_content, false));
        addField(form, 'BBQR Suchbegriff', clean(touch.campaign.utm_term, false));
        addField(form, 'BBQR Einstiegsseite', pathOnly(new URL(touch.landing_path, window.location.origin)));
        addField(form, 'BBQR Verweis', touch.referrer_host);
        addField(form, 'BBQR Quellenstatus', Object.keys(touch.campaign).length ? 'UTM-Parameter vorhanden' : Object.keys(touch.clicks).length ? 'Anzeigenklick-ID vorhanden; Kampagne nicht uebergeben' : touch.referrer_host ? 'Verweis vorhanden; Anzeigenzuordnung nicht gesichert' : 'Keine Kampagnen- oder Verweisinformation vorhanden');
        if (allowed.marketing) clickKeys.forEach(function (key) { addField(form, 'BBQR ' + key, clean(touch.clicks[key], true)); });
      }
      if (form.querySelector('[name="contact[BBQ Optionen als Orientierung]"]')) {
        write(pendingKey, { reference: reference, recorded_at: Date.now(), path: window.location.pathname });
      }
    } catch (error) {}
  }

  function referenceFor(eventId) {
    var allowed = consent();
    if (!allowed.analytics && !allowed.marketing) return eventId;
    var mapped = read(referencePrefix + eventId);
    if (referenceValid(mapped)) return mapped;
    var pending = read(pendingKey);
    if (pending && referenceValid(pending.reference) && pending.path === window.location.pathname && typeof pending.recorded_at === 'number' && Date.now() - pending.recorded_at >= 0 && Date.now() - pending.recorded_at < maxAge) {
      write(referencePrefix + eventId, pending.reference);
      remove(pendingKey);
      return pending.reference;
    }
    return eventId;
  }

  function campaignForEvent() {
    var allowed = consent();
    if ((!allowed.analytics && !allowed.marketing) || !validRecord(record)) return {};
    var campaign = record.last.campaign;
    return { bbqr_source: clean(campaign.utm_source, false), bbqr_medium: clean(campaign.utm_medium, false), bbqr_campaign: clean(campaign.utm_campaign, false), bbqr_content: clean(campaign.utm_content, false) };
  }

  window.BBQRLeadAttributionV1 = { referenceFor: referenceFor, campaignForEvent: campaignForEvent };
  document.addEventListener('submit', prepareForm, true);
  document.addEventListener('visitorConsentCollected', refresh);
  function initialize() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) {
        try { refresh(); } catch (refreshError) {}
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
